import React from "react";

const style = {
  backgroundColor: "#222222",
  color: "#61DAFB",
  padding: "10px",
  borderRadius: "5px"
};

const E404 = () => (
  <div>
    <h1>Error 404 </h1>
    <code style={style}>
      {window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        window.location.pathname}
    </code>
    <p>not found</p>
  </div>
);
export default E404;
